export default "__VITE_ASSET__KGfx$ES$__"